import { render, staticRenderFns } from "./BlogPostListItem.vue?vue&type=template&id=0a43bdb3&scoped=true"
import script from "./BlogPostListItem.vue?vue&type=script&lang=js"
export * from "./BlogPostListItem.vue?vue&type=script&lang=js"
import style0 from "./BlogPostListItem.vue?vue&type=style&index=0&id=0a43bdb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a43bdb3",
  null
  
)

export default component.exports